







 import { Component, Prop, Vue } from 'vue-property-decorator';
 import $ from 'jquery';
 require('./../modernizr-custom');
import _ from 'lodash';
 import screenfull, { Screenfull } from "screenfull";

 @Component({})
 export default class FullScreenRequire extends Vue {
     @Prop( {
         // default: Number.POSITIVE_INFINITY
         default: 1000,
         type: Number
     })
     private maxwidth?: number;
     private showContent:boolean = false;
     private hasSupport:boolean = false;
     private fullScreenState:boolean = false;
     private reSizeDebounceCooldown:number = 300;

     private created () {
         this.hasSupport = Modernizr.fullscreen;
         this.isContentVisible();
     }

     mounted() {
       if(this.hasSupport) {
           window.addEventListener('fullscreenchange', this.updateFullScreenState);
       }
         window.addEventListener('resize', _.debounce(this.isContentVisible, this.reSizeDebounceCooldown));
         this.isContentVisible();
     }

     destroyed() {
         window.removeEventListener('fullscreenchange', this.updateFullScreenState);
         window.removeEventListener('resize', _.debounce(this.isContentVisible, this.reSizeDebounceCooldown));
     }

     private updateFullScreenState() {
         this.fullScreenState = !!document.fullscreenElement;
         this.isContentVisible();
     }




     private isContentVisible() {
         this.showContent =  window.innerWidth > this.$props.maxwidth ||
             (!(screenfull.isEnabled)) ||
             (screenfull as Screenfull).isFullscreen;
     }
 }
